import { apiFetch, buildApiError } from './httpClient';

async function http(path, options = {}) {
  const resp = await apiFetch(path, options);
  if (!resp.ok) {
    throw await buildApiError(resp, 'User request failed');
  }
  if (resp.status === 204) return null;
  return resp.json();
}

export const userService = {
  getUser: (id) => http(`/api/users/${id}`),
  updateUser: (id, fields) => http(`/api/users/${id}`, { method: 'PATCH', body: JSON.stringify(fields) }),
};
